
import React from "react";
import { Button } from "@/components/ui/button";
import Footer from "@/components/Footer";

const Uninstall = () => {
  return (
    <div className="min-h-screen flex flex-col">
      {/* Header */}
      <header className="border-b border-gray-200 py-4 px-6">
        <div className="flex items-center">
          <a href="https://searchsafesecurity.com" className="flex items-center">
            <img 
              src="/lovable-uploads/522d17fa-541b-46b2-aec6-aec8edf40b37.png" 
              alt="PDF Search Helper" 
              className="h-12" 
              loading="eager"
            />
          </a>
        </div>
      </header>

      <div className="container mx-auto px-4 py-12 flex-grow">
        <div className="max-w-3xl mx-auto">
          <div className="mb-8">
            <a href="https://searchsafesecurity.com" className="text-blue-600 hover:underline flex items-center gap-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="m15 18-6-6 6-6"/>
              </svg>
              Back to Home
            </a>
          </div>
          
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">How to Uninstall the PDF Search Helper Extension</h1>
          
          <div className="prose max-w-none">
            <p className="text-lg text-gray-700 mb-6">
              Follow these simple steps to remove the PDF Search Helper extension from your Chrome browser:
            </p>
            
            <div className="bg-gray-50 p-6 rounded-lg mb-8">
              <h2 className="text-xl font-semibold mb-4">Chrome Uninstall Instructions</h2>
              <ol className="list-decimal pl-5 space-y-4">
                <li className="text-gray-700">
                  <span className="font-medium">Open Chrome Extensions</span>
                  <p>Click the three dots menu (⋮) in the top-right corner of your browser, then navigate to "More tools" &gt; "Extensions".</p>
                </li>
                <li className="text-gray-700">
                  <span className="font-medium">Find the PDF Search Helper Extension</span>
                  <p>Locate the "PDF Search Helper" extension in your list of installed extensions.</p>
                </li>
                <li className="text-gray-700">
                  <span className="font-medium">Remove the Extension</span>
                  <p>Click the "Remove" button associated with the PDF Search Helper extension.</p>
                </li>
                <li className="text-gray-700">
                  <span className="font-medium">Confirm Removal</span>
                  <p>A confirmation dialog will appear. Click "Remove" again to confirm you want to uninstall the extension.</p>
                </li>
              </ol>
            </div>
            
            <p className="text-gray-700 mb-6">
              After completing these steps, the PDF Search Helper extension will be completely removed from your Chrome browser.
            </p>
          </div>
          
          <div className="mt-12 text-center">
            <Button asChild className="bg-[rgb(86,104,241)] hover:bg-[rgb(86,104,241)]/90">
              <a href="https://searchsafesecurity.com">
                Return to Homepage
              </a>
            </Button>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Uninstall;
